<template>
  <div class="col-xl-3 col-mlg-4 col-lg-6 d-flex">
    <article class="recent-page page-block" :class="{ 'locked': disabled}">
      <a class="p-2 pb-0" :href="item.editUrl" @click="editPage">
        <div class="thumbnail overflow" v-if="item.thumbnail">
          <img src="@/core/assets/recentPage.jpg" />
        </div>
        <div class="thumbnail" v-else>
          <!-- <img v-lazyload src="../../assets/img/placeholder.png" data-src="https://picsum.photos/3300/3300"> -->
          <svg width="213" viewBox="0 0 213 231" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="213" height="72" rx="5" />
            <rect y="122" width="112" height="28" rx="5" />
            <path
              d="M0 169C0 166.239 2.23858 164 5 164H208C210.761 164 213 166.239 213 169V231H0V169Z"
            />
            <rect y="82" width="110" height="9" rx="4.5" />
            <rect y="101" width="73" height="9" rx="4.5" />
            <rect x="120" y="122" width="93" height="9" rx="4.5" />
            <rect x="120" y="141" width="71" height="9" rx="4.5" />
          </svg>
        </div>

        <div class="info">
          <div class="page-type d-flex align-items-center mb-1">
            <template v-if="item.type == 'template-page'">
              <i class="icon icon-landingpages text-grey2"></i>
            </template>
            <template v-if="item.type == 'template-index'">
              <i class="icon icon-homepages text-grey2"></i>
            </template>
            <template v-if="item.type == 'template-collection'">
              <i class="icon icon-collectionpages text-grey2"></i>
            </template>
            <template v-if="item.type == 'template-product'">
              <i class="icon icon-productpages text-grey2"></i>
            </template>
            <template v-if="item.type == 'template-article'">
              <i class="icon icon-blog text-grey2"></i>
            </template>
            <span class="ml-half d-flex align-items-center text-grey2" v-if="isDefault">
              <svg width="14" viewBox="0 0 16 16" fill="none" class="mx-half">
                <path
                  d="M13 3L6.2925 12.5808C6.204 12.7079 6.08654 12.8122 5.94982 12.8851C5.81309 12.958 5.66101 12.9973 5.5061 12.9999C5.35119 13.0024 5.19788 12.9681 5.05882 12.8998C4.91976 12.8315 4.79893 12.7312 4.70627 12.607L2 9"
                  stroke="#42C184"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              {{$t("generals.default")}}
            </span>
          </div>
          <p class="typo-title1 title">{{ item.title }}</p>
          <p class="typo-tiny11 time">{{ timeago }}</p>
        </div>
      </a>

      <div class="actions flex-v-center pb-2 px-2" @click.native.stop.prevent>
        <a @click="editPage" class="action flex-v-center edit typo-body2">
          <i class="icon icon-edit mr-1"></i>
          {{$t("generals.edit")}}
        </a>
        <a target="_blank" :href="item.previewUrl" class="action flex-v-center view typo-body2">
          <i class="icon icon-view mr-1"></i>
          {{$t("generals.view")}}
        </a>
        <PageItemDropdown
          class="ml-auto mb-n2 mr-n2 pb-2 pr-2 mt-nhalf"
          :page="item"
          :pageType="pageType"
          :positioning="false"
        />
      </div>

      <div class="locked-overlay" v-if="disabled">
        <!-- <svg
          viewBox="0 0 14 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="lock-icon"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.16667 6.83333V13.8333H12.8333V6.83333H1.16667ZM0.777778 5.66666C0.348223 5.66666 0 6.01489 0 6.44444V14.2222C0 14.6518 0.348223 15 0.777778 15H13.2222C13.6518 15 14 14.6518 14 14.2222V6.44444C14 6.01489 13.6518 5.66666 13.2222 5.66666H0.777778Z"
            fill="currentColor"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.70406 3.23588C3.10431 4.20208 2.91667 5.43908 2.91667 6.44444H1.75C1.75 5.33252 1.95138 3.84729 2.71283 2.62059C3.49971 1.35294 4.85373 0.416664 7.00013 0.416664C9.14654 0.416664 10.5005 1.35294 11.2873 2.62061C12.0487 3.84732 12.25 5.33255 12.25 6.44446L11.0833 6.44442C11.0834 5.43905 10.8958 4.20206 10.2961 3.23586C9.72181 2.31063 8.74248 1.58333 7.00013 1.58333C5.25778 1.58333 4.27839 2.31064 3.70406 3.23588Z"
            fill="currentColor"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.99984 9.55556C7.322 9.55556 7.58317 9.81672 7.58317 10.1389V11.6944C7.58317 12.0166 7.322 12.2778 6.99984 12.2778C6.67767 12.2778 6.4165 12.0166 6.4165 11.6944V10.1389C6.4165 9.81672 6.67767 9.55556 6.99984 9.55556Z"
            fill="currentColor"
          />
        </svg>-->
      </div>
    </article>
  </div>
</template>

<script>
import PageItemDropdown from "@/core/shared/GpList/components/PageItemDropdown.vue";
import { TimeMaker } from "@/plugins";
import { mapGetters } from "vuex";
export default {
  name: "RecentPage",
  components: {
    PageItemDropdown
  },
  filters: {},
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("account", {
      language: "displayLanguage"
    }),
    timeago() {
      return new TimeMaker(this.item.updated_at).ago(this.language);
    },
    pageType() {
      let arr = {
        "template-page": "subpages",
        "template-article": "articlepages",
        "template-collection": "collectionpages",
        "template-product": "productpages",
        "template-index": "homepages"
      };
      if (this.item) {
        return arr[this.item.type];
      }
      return [];
    },
    isDefault() {
      if (this.layoutDefaultStatus) {
        return this.item.published;
      }
      return false;
    },
    layoutDefaultStatus() {
      let defaultPages = [
        "template-collection",
        "template-index",
        "template-product"
      ];
      return defaultPages.includes(this.item.type) ? true : false;
    },
    currentPage() {
      let currentPageText = {
        "template-index": `| ${this.$t("page.currentHome")}`,
        "template-product": `| ${this.$t("page.currentProduct")}`,
        "template-collection": `| ${this.$t("page.currentCollection")}`
      };
      return this.isDefault ? currentPageText[this.item.type] : "";
    }
  },
  methods: {
    toggleDropdown() {
      let $dropdown = this.$refs.moreAction;
      if ($dropdown && $dropdown.toggleDropdown) $dropdown.toggleDropdown();
    },
    handleGotoBuilder() {
      // this.$store.commit("LOAD_NOTICE", "Going to Builder");
    },
    editPage() {
      if (this.disabled) {
        return false;
      }
      this.handleGotoBuilder();
      let domain = document.body.getAttribute("data-domain");
      window.location.assign(domain + "" + this.item.editUrl);
    }
  }
};
</script>

<style lang="scss" scoped>
.recent-page {
  background: #fff;
  width: 100%;
  &.page-block {
    padding: 0;
  }
  cursor: pointer;
  @include trans-all;
  .thumbnail {
    flex: 1;
    max-height: 171px;
    overflow: hidden;
    margin-bottom: 16px;
    border-radius: 10px 10px 0 0;
    &.overflow {
      margin: -16px -16px 16px -16px;
    }
    img {
      width: 100%;
    }
    svg {
      width: 100%;
      path,
      rect {
        fill: $cTeal;
      }
    }
  }
  .info {
    margin-top: auto;
    margin-bottom: 20px;

    .page-type {
      i.icon {
        font-size: 16px;
      }
    }

    > svg,
    .title {
      margin-bottom: 4px;
    }

    .title {
      color: $cPrimary;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
    }

    .time {
      color: $shade6;
    }
  }

  .actions {
    margin-top: auto;
    cursor: default;
    .action {
      color: $cSecondary4;
      padding: 5px 1px;
      margin-right: 24px;
      @include trans-all;
      flex-wrap: wrap;

      i.icon {
        font-size: 16px;
      }

      &:hover {
        cursor: pointer;
        color: $cPrimary;
      }
    }
    ::v-deep {
      .dropdown_toggle {
        padding: 5px;
      }
      .gp_dropdown_list {
        width: 167px;
        top: -50px;
        right: 0;

        .dropdown_item {
          padding: 8px;
        }
      }
    }
  }

  &:not(.locked):hover {
    box-shadow: 0px 7px 64px rgba(0, 24, 46, 0.15);
  }

  &.locked {
    position: relative;
    & > .locked-overlay {
      @include flex-center;
      position: absolute;
      cursor: default;
      content: "";
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      // background: rgba(#050e3f, 0.35);
      border-radius: 10px;
      .lock-icon {
        width: 60px;
        color: #ececec;
      }
    }
  }
}
</style>
